import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Box } from '@mui/material';
import useGetEventLogTypesLocal from '@src/adapters/hooks/eventLog/useGetEventLogTypesLocal';

interface Props {
  selection(name: string | null): void;
  selected: string | null;
  group: string | null;
}

function EventLogNameAutoComplete({ selection, selected, group }: Props) {
  const [open, setOpen] = useState(false);
  const { getTypes } = useGetEventLogTypesLocal();
  const [availableNames, setAvailableNames] = useState<string[]>([]);
  const loading = open;

  useEffect(() => {
    if (group) {
      const fetchGroups = async () => {
        const types = await getTypes();
        const names = types.filter((t) => t.group === group);
        const namesToShow = names.map((t) => t.name);
        setAvailableNames(namesToShow);
      };
      fetchGroups();
    } else {
      setAvailableNames([]);
    }
  }, [getTypes, group]);

  const onOpen = () => {
    setOpen(true);
  };

  return (
    <Box>
      <Autocomplete
        open={open}
        onOpen={onOpen}
        disabled={!group}
        onClose={() => {
          setOpen(false);
        }}
        onChange={(option, value) => {
          selection(value);
        }}
        value={selected}
        isOptionEqualToValue={(option, value) => option === value}
        getOptionLabel={(option) => option.split('_').join(' ')}
        options={availableNames}
        loading={loading}
        filterSelectedOptions={true}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Event Name"
            variant="standard"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </Box>
  );
}
export default EventLogNameAutoComplete;
